import { motion } from 'framer-motion';

/**
 * Banner d'introduction professionnelle, affiche une phrase d'impact
 * pour chaque page du site. Variations de couleurs par accent.
 *
 * Usage:
 *  <PageIntro accent="yellow" tagline="Une famille d'artistes, plusieurs continents, une seule vibration." />
 */
const ACCENT = {
  yellow: { txt: 'text-yellow-400', from: 'from-yellow-500/15', via: 'via-amber-500/5' },
  amber:  { txt: 'text-amber-400',  from: 'from-amber-500/15',  via: 'via-orange-500/5' },
  orange: { txt: 'text-orange-400', from: 'from-orange-500/15', via: 'via-red-500/5' },
  pink:   { txt: 'text-pink-400',   from: 'from-pink-500/15',   via: 'via-rose-500/5' },
  green:  { txt: 'text-green-400',  from: 'from-green-500/15',  via: 'via-teal-500/5' },
  red:    { txt: 'text-red-400',    from: 'from-red-500/15',    via: 'via-orange-500/5' },
  purple: { txt: 'text-purple-400', from: 'from-purple-500/15', via: 'via-violet-500/5' },
};

export default function PageIntro({ tagline, accent = 'yellow', label, align = 'center' }) {
  const a = ACCENT[accent] || ACCENT.yellow;
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      className={`relative overflow-hidden border-y border-white/5 bg-gradient-to-r ${a.from} ${a.via} to-transparent`}
      data-testid="page-intro-banner">
      <div className={`max-w-7xl mx-auto px-4 sm:px-8 py-4 sm:py-5 ${align === 'left' ? 'text-left' : 'text-center'}`}>
        {label && (
          <p className={`text-[10px] sm:text-xs font-bold uppercase tracking-[0.25em] ${a.txt} mb-1`}>
            {label}
          </p>
        )}
        <p className="text-base sm:text-lg lg:text-xl font-semibold text-white/90 italic leading-snug">
          &laquo; {tagline} &raquo;
        </p>
      </div>
    </motion.div>
  );
}
